module.exports = __webpack_public_path__ + "img/icp.1dedc985.jpg";